module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-close-my-issue-53.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-close-my-issue.md
// module id = 754
// module chunks = 182